import moment, { Moment } from 'moment';

import { MaterialDate } from '@shared/components/date-picker';

export const calculateLeaseEndDate = (dates: {
  lease_start?: MaterialDate;
  lease_length_years?: string;
  lease_length_months?: string;
  lease_length_days?: string;
}): Moment => {
  const leaseStartDate = moment(dates.lease_start);
  const leaseEndDate = leaseStartDate
    .add(dates.lease_length_years, 'years')
    .add(dates.lease_length_months, 'months')
    .add(dates.lease_length_days, 'days')
    .subtract(1, 'days'); // Subtract a day - a lease effectively finishes at the end of the day before

  // Only set lease end if >= lease start
  if (leaseEndDate.isBefore(leaseStartDate)) {
    return leaseStartDate;
  }

  return leaseEndDate;
};
